module.exports = __webpack_public_path__ + "static/media/blue-tile.a4a053aa.png";